import { render, staticRenderFns } from "./LoginModal.vue?vue&type=template&id=5ed49904&scoped=true&lang=html&"
import script from "./LoginModal.vue?vue&type=script&lang=js&"
export * from "./LoginModal.vue?vue&type=script&lang=js&"
import style0 from "./LoginModal.vue?vue&type=style&index=0&id=5ed49904&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ed49904",
  null
  
)

export default component.exports